import { render, staticRenderFns } from "./paymenttermdetail.vue?vue&type=template&id=2240cebe"
import script from "./paymenttermdetail.vue?vue&type=script&lang=js"
export * from "./paymenttermdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports